import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState, useMemo, useCallback } from "react";
import AutoSelect from "../AutoSelect";
import Box from "../Box";
import { createEmptyAppliedFilter } from ".";
const ListFilterSingleSelect = _ref => {
  let {
    searchFilter,
    appliedSearchFilter,
    onChangeAppliedFilter
  } = _ref;
  const [inputValue, setInputValue] = useState(null);
  const appliedFilterValues = useMemo(() => {
    return (appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues.length) > 0 ? appliedSearchFilter.filterValues : [];
  }, [appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues //needed to shallow compare changes 
  ]);
  const appliedFilterListValuesOption = useMemo(() => {
    if (appliedFilterValues.length > 0) {
      return {
        value: appliedFilterValues[0].value,
        label: appliedFilterValues[0].label
      };
    } else {
      return {
        value: "",
        label: ""
      };
    }
  }, [appliedFilterValues]);
  const handleChangeValue = useCallback((e, valueOption) => {
    if (valueOption != null) {
      const filterValues = []; //Note: even though its single select we commonize the way we pass back data in an array
      const filterValue = {
        value: valueOption.value,
        label: valueOption.label,
        context: null
      };
      filterValues.push(filterValue);
      const newAppliedSearchFilter = appliedSearchFilter ? appliedSearchFilter : createEmptyAppliedFilter(searchFilter);
      newAppliedSearchFilter.filterValues = filterValues;
      newAppliedSearchFilter.displayLabel = "".concat(searchFilter.label, ": ").concat(valueOption.label);
      onChangeAppliedFilter(searchFilter, newAppliedSearchFilter);
    } else {
      onChangeAppliedFilter(searchFilter, null);
    }
  }, [searchFilter, appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues,
  //needed to shallow compare changes 
  onChangeAppliedFilter, createEmptyAppliedFilter]);
  const handleChangeInput = useCallback((e, value, reason) => {
    setInputValue(value);
  }, []);
  const {
    label,
    placeholder = "Select"
  } = searchFilter;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(AutoSelect, {
    id: searchFilter.id,
    placeholder: placeholder,
    onChange: handleChangeValue,
    label: null,
    ariaLabel: searchFilter.label,
    value: appliedFilterListValuesOption,
    getOptionSelected: (option, value) => option.value === value.value,
    isOptionEqualToValue: (option, value) => option.value === value.value,
    inputValue: inputValue,
    onInputChange: handleChangeInput,
    options: searchFilter.options
  }));
};
export default ListFilterSingleSelect;